import { CampaignTargetProviderDef } from "@flow/common/campaign_target_provider";
import { error } from "@flow/lib/error";
import { Member, PublicCampaignTarget } from "@flow/common/types";

export interface CampaignTargetProvider<T> {
  def: CampaignTargetProviderDef<T>;

  memberTargetLookupWidget: React.FC<{
    config: T;
    member: Member;
    onUpdateMember: (new_member: Member) => void;
    onGetTarget: (targets: PublicCampaignTarget[]) => void;
  }>;
}

const campaign_target_provider_handlers: Map<string, CampaignTargetProvider<any>> = new Map();

export function getCampaignTargetProviderHandlers(): Readonly<typeof campaign_target_provider_handlers> {
  return campaign_target_provider_handlers;
}

export function registerCampaignTargetProvider<T>(handler: CampaignTargetProvider<T>) {
  if (campaign_target_provider_handlers.has(handler.def.provider_unique_id)) {
    error(
      `A campaign_target_provider handler for provider_unique_id '${handler.def.provider_unique_id}' is already registered`
    );
  } else {
    campaign_target_provider_handlers.set(handler.def.provider_unique_id, handler);
  }
}
